(function ($) {
  DJ.addBehavior('headerSearch', '.header-search', {
    attach: function () {
      const search = this;
      const searchBtnMenu = search.querySelector('.header-search__btn-menu');
      const searchDropDown = search.querySelector('.header-search__dropdown');
      const btnOpen = document.querySelector('.region-header__btn-menu');
      const headerNavHolder = document.querySelector('.region-header__holder-main');
      const headerOverlay = document.querySelector('.region-header-menu-overlay');

      /**
       * Open/close search dropdown.
       */
      const toggleDropDown = () => {
        searchDropDown.classList.toggle('header-search__dropdown--opened');
      };

      /**
       * Close navigation menu(mobile) on search open.
       */
      const closeNavigation = () => {
        document.getElementsByTagName('html')[0].classList.remove('html--locked');
        if (btnOpen && btnOpen.classList.contains('region-header__btn-menu--active')) {
          btnOpen.classList.remove('region-header__btn-menu--active');
        }

        if (headerOverlay && headerOverlay.classList.contains('region-header-menu-overlay--active')) {
          headerOverlay.classList.remove('region-header-menu-overlay--active');
        }

        if (headerNavHolder && headerNavHolder.classList.contains('region-header__holder-main--opened')) {
          headerNavHolder.classList.remove('region-header__holder-main--opened');
          headerNavHolder.style.height = 'auto';
        }
      };

      /**
       * Close dropdown on body click.
       */
      const onBodyClose = () => {
        $('body').on('click.bodyCloseHeaderSearch', (e) => {
          if (!($(e.target).closest('.header-search').length)) {
            searchDropDown.classList.remove('header-search__dropdown--opened');
          }
        });
      };

      /**
       * Open/close search dropdown on search button click.
       */
      if (searchBtnMenu && searchDropDown) {
        searchBtnMenu.addEventListener('click', () => {
          $('body').off('click.bodyCloseHeaderSearch');
          onBodyClose();
          closeNavigation();
          toggleDropDown();
        });
      }
    }
  });
})(jQuery);
